module.exports = __webpack_public_path__ + "img/schnittkante_brillantgelb_farbnr119.98dc26f8.jpg";